export const VEHICLE_STATE_IDS = {
  NEW: 'NEW',
  USED: 'USED'
}

export const VEHICLE_STATE_LITERALS = {
  [VEHICLE_STATE_IDS.NEW]: 'COMMON.OFFER_TYPE.NEW',
  [VEHICLE_STATE_IDS.USED]: 'COMMON.PRE_OWNED'
}

export const RENTING_CHEAP_PRICE = '400'

export const TARGET_BUYER_IDS = {
  PRIVATES: 'PRIVATES',
  BUSINESS: 'BUSINESS'
}

export const TARGET_BUYER = {
  [TARGET_BUYER_IDS.PRIVATES]: 'particulares',
  [TARGET_BUYER_IDS.BUSINESS]: 'empresas'
}

export const VEHICLE_TYPES = {
  INDUSTRIAL: 'furgonetas'
}

export const CONTEXTS = {
  DETAIL: 'detail',
  HOME: 'home'
}

export const DEFAULT_RELATED_ADS_COUNT = 4

/**
 * @exports SEGMENTS
 * Subscription segments
 *
 */
export const SEGMENTS = {
  COMPACT: 'Compacto',
  PREMIUM: 'Premium',
  PROFESSIONAL: 'Profesional',
  SMALL: 'Pequeño',
  SUV: 'SUV'
}

export const DEFAULT_SEGMENT = SEGMENTS.COMPACT

export const FALLBACK_ADS = [
  {
    make: 'Mini',
    model: 'One',
    version: '',
    minimumMonthlyFee: 299,
    segment: 'Pequeño',
    title: 'Mini One',
    imgUrl:
      'https://cdn.bipicar.com/specificvehicleplans/60a26589a9e879008cd913f1/vehicle-images/60a4fa1c9e27110084ffd039_2021_05_19_13_44_28.png',
    url: 'https://bipicar.uinterbox.com/tracking/clk?act=7935&gel=45649&pub=6156&org=1441&url=https%3A%2F%2Fbipicar.com%2Fes%2Fes%2Fcoches%2Fmini%2Fone%2F60a26589a9e879008cd913f1%3Fmileage%3D1000%26commitment%3D24'
  },
  {
    make: 'BMW',
    model: 'X1',
    version: '',
    minimumMonthlyFee: 399,
    segment: 'SUV',
    title: 'BMW X1',
    imgUrl:
      'https://cdn.bipicar.com/specificvehicleplans/5d97406a250eb100247c6859/vehicle-images/5e9d5d41f5d8e700aeb66129_2020_04_20_10_28_49.png',
    url: 'https://bipicar.uinterbox.com/tracking/clk?act=7935&gel=45649&pub=6156&org=1441&url=https%3A%2F%2Fbipicar.com%2Fes%2Fes%2Fcoches%2Fbmw%2Fx1%2F606dabe570f1d60093009bd4'
  },
  {
    make: 'Volkswagen',
    model: 'Golf',
    version: '',
    minimumMonthlyFee: 329,
    segment: 'Compacto',
    title: 'Volkswagen Golf',
    imgUrl:
      'https://cdn.bipicar.com/specificvehicleplans/5e385095d570fd00a4088e8b/vehicle-images/5e57afa4f13dd600a65488fe_2020_02_27_13_01_40.png',
    url: 'https://bipicar.uinterbox.com/tracking/clk?act=7935&gel=45649&pub=6156&org=1441&url=https%3A%2F%2Fbipicar.com%2Fes%2Fes%2Fcoches%2Fvolkswagen%2Fgolf%2F5fc643f027e76100a3e46047%3Fmileage%3D1000%26commitment%3D24'
  },
  {
    make: 'Mercedes-Benz',
    model: 'Clase GLC',
    version: '',
    minimumMonthlyFee: 749,
    segment: 'Premium',
    title: 'Mercedes-Benz Clase GLC',
    imgUrl:
      'https://cdn.bipicar.com/specificvehicleplans/5e31719560f12400ac8f5a63/vehicle-images/5e42de86bdec8e00aa3cd4a5_2020_02_11_18_04_06.png',
    url: 'https://bipicar.uinterbox.com/tracking/clk?act=7935&gel=45649&pub=6156&org=1441&url=https%3A%2F%2Fbipicar.com%2Fes%2Fes%2Fcoches%2Fmercedes%2Fglc%2F60a27478d88f0f0083c013c6%3Fmileage%3D1000%26commitment%3D36'
  },
  {
    make: 'Seat',
    model: 'Leon',
    version: '',
    minimumMonthlyFee: 329,
    segment: 'Compacto',
    title: 'Seat Leon',
    imgUrl:
      'https://cdn.bipicar.com/specificvehicleplans/5e25742c90472300a55606fc/vehicle-images/5ea2d4a0b828da00abdbe41b_2020_04_24_13_59_28.png',
    url: 'https://bipicar.uinterbox.com/tracking/clk?act=7935&gel=45649&pub=6156&org=1441&url=https%3A%2F%2Fbipicar.com%2Fes%2Fes%2Fcoches%2Fseat%2Fleon%2F5e25742c90472300a55606fc'
  },
  {
    make: 'Ford',
    model: 'Focus',
    version: '',
    minimumMonthlyFee: 329,
    segment: 'Compacto',
    title: 'Ford Focus',
    imgUrl:
      'https://cdn.bipicar.com/specificvehicleplans/5c8b6445c99757002275d32f/vehicle-images/5e4ba7eff5cb4500ae18b81b_2020_02_18_10_01_35.png',
    url: 'https://bipicar.uinterbox.com/tracking/clk?act=7935&gel=45649&pub=6156&org=1441&url=https%3A%2F%2Fbipicar.com%2Fes%2Fes%2Fcoches%2Fford%2Ffocus%2F5c8b6445c99757002275d32f'
  }
]

/**
 * @exports modelIdMapping
 * Mapping our modelIds to Subscription segments
 *
 */
export const modelIdMapping = {
  89: SEGMENTS.COMPACT,
  410: SEGMENTS.COMPACT,
  345: SEGMENTS.COMPACT,
  449: SEGMENTS.COMPACT,
  38: SEGMENTS.COMPACT,
  17: SEGMENTS.COMPACT,
  67: SEGMENTS.COMPACT,
  109: SEGMENTS.SMALL,
  275: SEGMENTS.SMALL,
  380: SEGMENTS.SMALL,
  90: SEGMENTS.SMALL,
  77: SEGMENTS.SMALL,
  97: SEGMENTS.COMPACT,
  353: SEGMENTS.COMPACT,
  168: SEGMENTS.COMPACT,
  293: SEGMENTS.COMPACT,
  138: SEGMENTS.COMPACT,
  447: SEGMENTS.COMPACT,
  187: SEGMENTS.COMPACT,
  799: SEGMENTS.COMPACT,
  273: SEGMENTS.COMPACT,
  94: SEGMENTS.COMPACT,
  287: SEGMENTS.COMPACT,
  272: SEGMENTS.COMPACT,
  622: SEGMENTS.COMPACT,
  60: SEGMENTS.COMPACT,
  156: SEGMENTS.COMPACT,
  405: SEGMENTS.COMPACT,
  525: SEGMENTS.COMPACT,
  277: SEGMENTS.COMPACT,
  532: SEGMENTS.COMPACT,
  42: SEGMENTS.COMPACT,
  303: SEGMENTS.COMPACT,
  69: SEGMENTS.COMPACT,
  37: SEGMENTS.COMPACT,
  971: SEGMENTS.COMPACT,
  1005: SEGMENTS.COMPACT,
  607: SEGMENTS.COMPACT,
  872: SEGMENTS.COMPACT,
  932: SEGMENTS.COMPACT,
  591: SEGMENTS.COMPACT,
  518: SEGMENTS.COMPACT,
  2: SEGMENTS.SMALL,
  86: SEGMENTS.SMALL,
  587: SEGMENTS.SMALL,
  485: SEGMENTS.SMALL,
  237: SEGMENTS.SMALL,
  322: SEGMENTS.SMALL,
  1130: SEGMENTS.SMALL,
  134: SEGMENTS.SMALL,
  966: SEGMENTS.SMALL,
  318: SEGMENTS.SMALL,
  250: SEGMENTS.SMALL,
  598: SEGMENTS.SMALL,
  216: SEGMENTS.SMALL,
  763: SEGMENTS.SMALL,
  903: SEGMENTS.SMALL,
  251: SEGMENTS.SMALL,
  477: SEGMENTS.SMALL,
  529: SEGMENTS.SMALL,
  484: SEGMENTS.SMALL,
  411: SEGMENTS.SMALL,
  75: SEGMENTS.SMALL,
  521: SEGMENTS.SMALL,
  34: SEGMENTS.SMALL,
  508: SEGMENTS.SMALL,
  1021: SEGMENTS.SMALL,
  916: SEGMENTS.SMALL,
  82: SEGMENTS.SMALL,
  502: SEGMENTS.SMALL,
  44: SEGMENTS.SMALL,
  555: SEGMENTS.SMALL,
  225: SEGMENTS.SMALL,
  442: SEGMENTS.SMALL,
  70: SEGMENTS.PREMIUM,
  7: SEGMENTS.PREMIUM,
  8: SEGMENTS.PREMIUM,
  71: SEGMENTS.PREMIUM,
  41: SEGMENTS.PREMIUM,
  27: SEGMENTS.PREMIUM,
  83: SEGMENTS.PREMIUM,
  611: SEGMENTS.PREMIUM,
  668: SEGMENTS.PREMIUM,
  360: SEGMENTS.PREMIUM,
  503: SEGMENTS.PREMIUM,
  258: SEGMENTS.PREMIUM,
  461: SEGMENTS.PREMIUM,
  515: SEGMENTS.PREMIUM,
  269: SEGMENTS.PREMIUM,
  904: SEGMENTS.PREMIUM,
  73: SEGMENTS.PREMIUM,
  724: SEGMENTS.PREMIUM,
  1084: SEGMENTS.PREMIUM,
  290: SEGMENTS.PREMIUM,
  1057: SEGMENTS.PREMIUM,
  260: SEGMENTS.PREMIUM,
  546: SEGMENTS.PREMIUM,
  994: SEGMENTS.PREMIUM,
  93: SEGMENTS.PREMIUM,
  542: SEGMENTS.PREMIUM,
  571: SEGMENTS.PREMIUM,
  291: SEGMENTS.PREMIUM,
  56: SEGMENTS.PREMIUM,
  115: SEGMENTS.PREMIUM,
  232: SEGMENTS.PREMIUM,
  177: SEGMENTS.PREMIUM,
  436: SEGMENTS.PREMIUM,
  880: SEGMENTS.PREMIUM,
  1100: SEGMENTS.PREMIUM,
  514: SEGMENTS.PREMIUM,
  486: SEGMENTS.PREMIUM,
  900: SEGMENTS.PREMIUM,
  4: SEGMENTS.PREMIUM,
  453: SEGMENTS.PREMIUM,
  573: SEGMENTS.PREMIUM,
  408: SEGMENTS.PREMIUM,
  1162: SEGMENTS.PREMIUM,
  105: SEGMENTS.PREMIUM,
  936: SEGMENTS.PREMIUM,
  750: SEGMENTS.PREMIUM,
  765: SEGMENTS.PREMIUM,
  905: SEGMENTS.PREMIUM,
  831: SEGMENTS.PREMIUM,
  1092: SEGMENTS.PREMIUM,
  282: SEGMENTS.PREMIUM,
  171: SEGMENTS.PREMIUM,
  407: SEGMENTS.PREMIUM,
  284: SEGMENTS.PREMIUM,
  55: SEGMENTS.PREMIUM,
  259: SEGMENTS.PREMIUM,
  1023: SEGMENTS.PREMIUM,
  923: SEGMENTS.PREMIUM,
  406: SEGMENTS.PREMIUM,
  323: SEGMENTS.PREMIUM,
  1097: SEGMENTS.PREMIUM,
  367: SEGMENTS.PREMIUM,
  167: SEGMENTS.PREMIUM,
  1217: SEGMENTS.PREMIUM,
  977: SEGMENTS.PREMIUM,
  678: SEGMENTS.PROFESSIONAL,
  645: SEGMENTS.PROFESSIONAL,
  681: SEGMENTS.PROFESSIONAL,
  666: SEGMENTS.PROFESSIONAL,
  674: SEGMENTS.PROFESSIONAL,
  648: SEGMENTS.PROFESSIONAL,
  664: SEGMENTS.PROFESSIONAL,
  670: SEGMENTS.PROFESSIONAL,
  773: SEGMENTS.PROFESSIONAL,
  545: SEGMENTS.PROFESSIONAL,
  633: SEGMENTS.PROFESSIONAL,
  635: SEGMENTS.PROFESSIONAL,
  663: SEGMENTS.PROFESSIONAL,
  682: SEGMENTS.PROFESSIONAL,
  1128: SEGMENTS.PROFESSIONAL,
  695: SEGMENTS.PROFESSIONAL,
  694: SEGMENTS.PROFESSIONAL,
  539: SEGMENTS.SUV,
  72: SEGMENTS.SUV,
  309: SEGMENTS.SUV,
  438: SEGMENTS.SUV,
  256: SEGMENTS.SUV,
  131: SEGMENTS.SUV,
  636: SEGMENTS.SUV,
  218: SEGMENTS.SUV,
  39: SEGMENTS.SUV,
  133: SEGMENTS.SUV,
  628: SEGMENTS.SUV,
  54: SEGMENTS.SUV,
  24: SEGMENTS.SUV,
  270: SEGMENTS.SUV,
  462: SEGMENTS.SUV,
  606: SEGMENTS.SUV,
  148: SEGMENTS.SUV,
  231: SEGMENTS.SUV,
  522: SEGMENTS.SUV,
  319: SEGMENTS.SUV,
  427: SEGMENTS.SUV,
  313: SEGMENTS.SUV,
  139: SEGMENTS.SUV,
  918: SEGMENTS.SUV,
  279: SEGMENTS.SUV,
  566: SEGMENTS.SUV,
  107: SEGMENTS.SUV,
  413: SEGMENTS.SUV,
  385: SEGMENTS.SUV,
  352: SEGMENTS.SUV,
  350: SEGMENTS.SUV,
  68: SEGMENTS.SUV,
  944: SEGMENTS.SUV,
  619: SEGMENTS.SUV,
  354: SEGMENTS.SUV,
  98: SEGMENTS.SUV,
  170: SEGMENTS.SUV,
  882: SEGMENTS.SUV,
  305: SEGMENTS.SUV,
  320: SEGMENTS.SUV,
  999: SEGMENTS.SUV,
  63: SEGMENTS.SUV,
  425: SEGMENTS.SUV,
  688: SEGMENTS.SUV,
  455: SEGMENTS.SUV,
  489: SEGMENTS.SUV,
  599: SEGMENTS.SUV,
  594: SEGMENTS.SUV,
  341: SEGMENTS.SUV,
  219: SEGMENTS.SUV,
  396: SEGMENTS.SUV,
  497: SEGMENTS.SUV,
  658: SEGMENTS.SUV,
  1016: SEGMENTS.SUV,
  982: SEGMENTS.SUV,
  962: SEGMENTS.SUV,
  976: SEGMENTS.SUV,
  609: SEGMENTS.SUV,
  685: SEGMENTS.SUV,
  153: SEGMENTS.SUV,
  934: SEGMENTS.SUV,
  592: SEGMENTS.SUV,
  600: SEGMENTS.SUV,
  137: SEGMENTS.SUV,
  357: SEGMENTS.SUV,
  950: SEGMENTS.SUV,
  310: SEGMENTS.SUV,
  1256: SEGMENTS.SUV
}

/**
 * @exports SEGMENTS
 * Maps subscription contexts to attribution link param values
 *
 */
export const SUBSCRIPTION_REFERRALS = {
  [CONTEXTS.DETAIL]: 'fichacoche-carrusel-suscripcion',
  [CONTEXTS.HOME]: 'home-carrusel-suscripcion'
}

export const URL_LANDING_SUBSCRIPTION = 'https://comunicacion.coches.net/renting/'
